import { ExpandMore } from "@mui/icons-material"
import AddIcon from "@mui/icons-material/Add"
import { Accordion, AccordionDetails, AccordionSummary, Typography, Button, Snackbar, Alert } from "@mui/material"
import KwilDB from "kwildb"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import AddPoolModal from "./fundingPoolList-components/AddPoolModal"
import PoolName from "./fundingPoolList-components/PoolNameButton"

export default function FundingPoolList({ privKey, initialPools }) {
    const [pools, setPools] = useState([])
    const [fundingLoader, setFundingLoader] = useState(false)
    const [addingPool, setAddingPool] = useState(false)
    const [count, setCount] = useState(0)
    const [status, setStatus] = useState(null)
    const [errMsg, setErrMsg] = useState("")
    const [enter, setEnter] = useState(false)

    const loadedMoat = useSelector((state) => state.loadedMoat.value)

    useEffect(() => {
        setFundingLoader(true)
        setTimeout(async function() {
            const result = await KwilDB.getPoolsByMoat(
                "https://registry.kwil.xyz",
                loadedMoat
            )
            setPools(result)
            setFundingLoader(false)
        })
    }, [privKey, count])
    
    return(
        <div
            style={{
                display: fundingLoader || privKey === "" ? "none" : "flex",
                flexDirection: "column"
            }}
        >
            <Accordion
                disableGutters
                sx={{
                    width: "100%",
                    backgroundColor: "transparent",
                    boxShadow: "none"
                }}
            >
                <AccordionSummary
                    sx={{
                        "& .MuiAccordionSummary-content": { margin: 0 },
                        "&.MuiAccordionSummary-root": {
                        maxHeight: "38px",
                        minHeight: "38px",
                        padding: "0 16px",
                        }
                    }}
                    expandIcon={<ExpandMore sx={{ color: enter ? "#118EA0" : "#fff" }}/>}
                    onMouseEnter={() => setEnter(true)}
                    onMouseLeave={() => setEnter(false)}
                >
                    <Typography sx={{ color: enter ? "#118EA0" : "#fff", fontWeight: "bold", fontFamily: "Averta"}}>
                        Funding Pools
                    </Typography>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        "&.MuiAccordionDetails-root": {
                            padding: "0px 16px 8px 16px"
                        }
                    }}
                >
                    {pools.map((pool, index) => {
                        return(
                            <PoolName
                                pool={pool}
                                index={index}
                            />
                        )
                    })}
                </AccordionDetails>
            </Accordion>
            <Button
                onClick={() => setAddingPool(true)}
                sx={{
                    display: fundingLoader ? "none" : "flex",
                    color: "#118EA0",
                    textTransform: "none",
                    justifyContent: "left",
                    fontWeight: "bold",
                    fontSize: "18px",
                    lineheight: "21px",
                    backgroundColor: "transparent",
                    padding: "0 16px",
                    fontFamily: "Averta",
                    width: "100%",
                    flexDirection: "row",
                    "& .MuiButton-endIcon": {
                        marginLeft: "auto"
                    },
                    "&:hover" : {color: "#fff"}
                }}
                endIcon={<AddIcon />}
            >
                Create Pool
            </Button>
            <div>  
                <AddPoolModal
                    addingPool={addingPool}
                    setAddingPool={setAddingPool}
                    pools={pools}
                    setPools={setPools}
                    setStatus={setStatus}
                    setErrMsg={setErrMsg}
                    count={count}
                    setCount={setCount}
                />
            </div>
            <Snackbar
                sx={{ margin: "0px auto" }}
                open={errMsg}
                autoHideDuration={4000}
                onClose={() => setErrMsg("")}
            >
                <Alert
                    variant="filled"
                    severity="error"
                    sx={{ width: "100%" }}
                    onClose={() => setErrMsg("")}
                >
                    Funding Pool name is alredy taken. Try a different name!
                </Alert>
            </Snackbar>
        </div>
    )
}